import { render, staticRenderFns } from "./faModule.vue?vue&type=template&id=689e57cb&scoped=true&"
import script from "./faModule.vue?vue&type=script&lang=js&"
export * from "./faModule.vue?vue&type=script&lang=js&"
import style0 from "./faModule.vue?vue&type=style&index=0&id=689e57cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689e57cb",
  null
  
)

export default component.exports